import React from 'react';

type Common = {
    label?: string;
    hint?: string;
    error?: string;
    className?: string;
};

export function Input({
    label,
    hint,
    error,
    className = '',
    id,
    ...rest
}: Common & React.InputHTMLAttributes<HTMLInputElement>) {
    const auto = React.useId();
    const uid = id || auto;
    return (
        <Field label={label} hint={hint} error={error} htmlFor={uid} className={className}>
            <span className={['ds-field__box', error ? 'ds-field__box--error' : ''].filter(Boolean).join(' ')}>
                <input id={uid} className="ds-field__input" {...rest} />
            </span>
        </Field>
    );
}

export function Textarea({
    label,
    hint,
    error,
    className = '',
    id,
    rows = 4,
    ...rest
}: Common & React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
    const auto = React.useId();
    const uid = id || auto;
    return (
        <Field label={label} hint={hint} error={error} htmlFor={uid} className={className}>
            <span
                className={['ds-field__box', 'ds-field__box--area', error ? 'ds-field__box--error' : '']
                    .filter(Boolean)
                    .join(' ')}
            >
                <textarea id={uid} className="ds-field__input" rows={rows} {...rest} />
            </span>
        </Field>
    );
}

function Field({
    label,
    hint,
    error,
    htmlFor,
    className,
    children,
}: Common & { htmlFor: string; children: React.ReactNode }) {
    return (
        <div className={['ds-field', className].filter(Boolean).join(' ')}>
            {label && (
                <label className="ds-field__label" htmlFor={htmlFor}>
                    {label}
                </label>
            )}
            {children}
            {(error || hint) && (
                <span className={['ds-field__hint', error ? 'ds-field__hint--error' : ''].filter(Boolean).join(' ')}>
                    {error || hint}
                </span>
            )}
        </div>
    );
}
